import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './sub.css';
import jphome from '../images/TRANSPARNT LOGO.png'
import contactConfig from '../confi';
const Header = ({ onRegisterClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServiceOpen, setIsServiceOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsServiceOpen(false);
  };

  const toggleService = () => {
    setIsServiceOpen(!isServiceOpen);
  };

  // Handle register button click
  const handleRegisterClick = (e) => {
    e.preventDefault();
    if (onRegisterClick) {
      onRegisterClick();
    }
    closeMenu();
  };

  useEffect(() => {
    const controlHeader = () => {
      if (typeof window !== 'undefined') {
        if (window.scrollY > lastScrollY) {
          // Scrolling down
          setVisible(false);
        } else {
          // Scrolling up
          setVisible(true);
        }
        setLastScrollY(window.scrollY);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlHeader);

      return () => {
        window.removeEventListener('scroll', controlHeader);
      };
    }
  }, [lastScrollY]);

  return (
    <header className={`header-main ${visible ? 'visible' : 'hidden'}`}>
      <div className="header-top">
        <div className="logo">
          <NavLink to="/" onClick={closeMenu} className="logo-link">
            <img 
              src={jphome}
              alt="Company Logo"
              className="logo-image"
            />
            <div className='JP'>“हर घर का सच्चा साथी – <div>JP Home Services”</div></div>
          </NavLink>
        </div>

        
        <div className="header-right">
          {/* Post Requirement Button */}
          <div className="header-btn post-requirement">
            <NavLink to="/post-requirement" onClick={closeMenu}>
              Post Requirement
            </NavLink>
          </div>

          {/* Need Job Button */}
          <div className="header-btn need-job">
            <NavLink to="/need-job" onClick={closeMenu}>
              Need Job
            </NavLink>
          </div>

          {/* 24x7 Assistant Button with Animation */}
          <div className="contact">
            <a
              href={`tel:${contactConfig.phone}`}
              className="mobile-btn call-btn"
              onClick={() => {
                return window.gtag_report_conversion
                  ? window.gtag_report_conversion(`${contactConfig.phone}`)
                  : true;
              }}
            >
              <span className="contact-icon1">☎</span>
              <span className="btn-text">Call Now</span>
              <span className="pulse-ring"></span>
              <span className="pulse-ring pulse-ring-2"></span>
            </a>
          </div>
          
          <div className="register">
            <NavLink to="/contact" onClick={closeMenu}>Contact Us</NavLink>
          </div>
          
          {/* Register Button - Opens Popup */}
          <div className="register">
            <NavLink to="/Book-Now" onClick={closeMenu}>Book Now</NavLink>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? (
            <span className="close-icon">✕</span>
          ) : (
            <>
              <span></span>
              <span></span>
              <span></span>
            </>
          )}
        </button>
      </div>

      <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          <li>
            <NavLink 
              to="/" 
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={closeMenu}
            >
              Home
            </NavLink>
          </li>
           <li>
            <NavLink 
              to="/aboutus" 
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={closeMenu}
            >
             About us
            </NavLink>
          </li>
          
          {/* Services Dropdown */}
          <div
            className="dropdown"
            onMouseEnter={() => setIsServiceOpen(true)}
            onMouseLeave={() => setIsServiceOpen(false)}
          >
          <button
            className={`dropdown-toggle ${isServiceOpen ? 'open' : ''}`}
            onClick={toggleService}
          >
            <span>Service</span>
            <span className="dropdown-icon">
              {isServiceOpen ? '▲' : '▼'}
            </span>
          </button>

          {/* IMPORTANT CHANGE HERE */}
          <div className={`dropdown-menu ${isServiceOpen ? 'show' : ''}`}>
            <li>
              <NavLink to="/house-maid-services-in-ahmedabad" onClick={closeMenu}>
                All Work House Maid
              </NavLink>
            </li>
            <li>
              <NavLink to="/cook-services-in-ahmedabad" onClick={closeMenu}>
                Cook
              </NavLink>
            </li>
            <li>
              <NavLink to="/baby-sitting-services-in-ahmedabad" onClick={closeMenu}>
                Baby Sitting
              </NavLink>
            </li>
            <li>
              <NavLink to="/elder-care-services-in-ahmedabad" onClick={closeMenu}>
                Elderly Care
              </NavLink>
            </li>
            <li>
              <NavLink to="/driver-services-in-ahmedabad" onClick={closeMenu}>
                Driver
              </NavLink>
            </li>
            <li>
              <NavLink to="/servant-services-in-ahmedabad-24-hours" onClick={closeMenu}>
                24x7 Servant
              </NavLink>
            </li>
            <li>
              <NavLink to="/patient-care-services-in-ahmedabad" onClick={closeMenu}>
                Patient Care
              </NavLink>
            </li>
            <li>
              <NavLink to="/office-boy-services-in-ahmedabad" onClick={closeMenu}>
                Office Boy
              </NavLink>
            </li>
          </div>
        </div>
          <li>
            <NavLink 
              to="/blog" 
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={closeMenu}
            >
              Blog
            </NavLink>
          </li>
        </ul>

        {/* Mobile Buttons */}
        <div className="mobile-buttons">
          <NavLink to="/post-requirement" className="mobile-btn post-requirement" onClick={closeMenu}>
            Post Requirement
          </NavLink>
          <NavLink to="/need-job" className="mobile-btn need-job" onClick={closeMenu}>
            Need Job
          </NavLink>
          <NavLink to="/contact" className="mobile-btn post-requirement" onClick={closeMenu}>
            Contact Us
          </NavLink>
          <a href="tel:+9124assistant" className="mobile-btn call-btn">
            <span className="contact-icon1">☎</span>
            <span className="btn-text">Call Now</span>
          </a>
        </div>

        {/* Close button inside mobile menu */}
        <button 
          className="mobile-close-btn"
          onClick={closeMenu}
          aria-label="Close menu"
        >
          ✕ Close
        </button>
      </nav>

      {/* Overlay for mobile menu */}
      {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
    </header>
  );
};

export default Header;